import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { MyDraggable as Draggable } from "../components/Core";
import HoverBar from "../components/HoverBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "reactstrap";
import { generateStyle, l, setOverLay } from "../functions";
import Icon from "../components/Icons";
import isEqual from "lodash/isEqual";

const mapStateToProps = (state) => {
  return {
    settings: state.rootReducer?.appearanceSettings || {},
  };
};

class FAIcon extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  shouldComponentUpdate(nextProp, nextState) {
    const currentPayload = this.props?.payload;
    const nextPayload = nextProp?.payload;

    // console.log(JSON.stringify(currentPayload) === JSON.stringify(nextPayload));
    if (isEqual(currentPayload, nextPayload)) {
      return false;
    }
    // console.log("re-render");
    return true;
  }

  _initIcon = (preview, blockPreview = false) => {
    let { payload } = this.props;

    if (blockPreview || payload === null) {
      payload = this.props.options.payload;
    }

    let { iconClass = "" } = payload.datas || {};
    const cssSettings = generateStyle(payload, "container");
    const cssSettingsText = generateStyle(payload, "text", "body");
    let cssAlignment = generateStyle(payload, "alignment");

    // if (!iconClass) {
    //   iconClass = ["fas", "ellipsis-h"];
    // }
    return (
      <Container fluid={payload.fullContainer}>
        {setOverLay(payload)}
        <Row>
          <Col xs={12}>
            <div style={cssAlignment}>
              <span className="custom-fa-icon" style={cssSettings}>
                {!preview && <div className="overlay"></div>}
                {iconClass == "fa-ad" && <Icon icon="dots" />}
                {iconClass && !Array.isArray(iconClass) && (
                  <span style={cssSettingsText}>
                    <FontAwesomeIcon
                      icon={["fas", iconClass.replace("fa-", "")]}
                      color={cssSettingsText?.color}
                    />
                  </span>
                )}
                {iconClass && Array.isArray(iconClass) && (
                  <span style={cssSettingsText}>
                    <FontAwesomeIcon
                      icon={[iconClass[0], iconClass[1]]}
                      color={cssSettingsText?.color}
                    />
                  </span>
                )}
                {!iconClass && (
                  <div class="gk-error-message">
                    <p>Please select an icon.</p>
                  </div>
                )}
              </span>
            </div>
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          {(options.showPreview && this._initIcon(false, true)) || (
            <span className="dragger">
              {(Array.isArray(rest.icon) && (
                <FontAwesomeIcon icon={rest.icon} />
              )) || <Icon icon={rest.icon} />}
              <span>{l(rest.name)}</span>
            </span>
          )}
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initIcon(true)}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initIcon()}
      </Draggable>
    );
  }
}

FAIcon.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, null)(FAIcon);
